import React, { forwardRef } from 'react';

const cardStyle = {
    backgroundColor: '#ffffff',
    borderRadius: '0.5rem',
    border: '1px solid #e5e7eb',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    marginBottom: '1rem' // Default margin
};

const cardHeaderStyle = {
    padding: '1.5rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.375rem'
};

const cardTitleStyle = {
    fontSize: '1.5rem',
    fontWeight: '600',
    lineHeight: '1',
    letterSpacing: '-0.025em'
};

const cardDescriptionStyle = {
    fontSize: '0.875rem',
    color: '#6b7280'
};

const cardContentStyle = {
    padding: '1.5rem',
    paddingTop: 0
};

const cardFooterStyle = {
    display: 'flex',
    alignItems: 'center',
    padding: '1.5rem',
    paddingTop: 0
};

const Card = forwardRef(({ className, style, ...props }, ref) => (
    <div
        ref={ref}
        style={{ ...cardStyle, ...style }}
        {...props}
    />
));
Card.displayName = "Card";

const CardHeader = forwardRef(({ className, style, ...props }, ref) => (
    <div
        ref={ref}
        style={{ ...cardHeaderStyle, ...style }}
        {...props}
    />
));
CardHeader.displayName = "CardHeader";

const CardTitle = forwardRef(({ className, style, ...props }, ref) => (
    <h3
        ref={ref}
        style={{ ...cardTitleStyle, ...style }}
        {...props}
    />
));
CardTitle.displayName = "CardTitle";

const CardDescription = forwardRef(({ className, style, ...props }, ref) => (
    <p
        ref={ref}
        style={{ ...cardDescriptionStyle, ...style }}
        {...props}
    />
));
CardDescription.displayName = "CardDescription";

const CardContent = forwardRef(({ className, style, ...props }, ref) => (
    <div
        ref={ref}
        style={{ ...cardContentStyle, ...style }}
        {...props}
    />
));
CardContent.displayName = "CardContent";

const CardFooter = forwardRef(({ className, style, ...props }, ref) => (
    <div
        ref={ref}
        style={{ ...cardFooterStyle, ...style }}
        {...props}
    />
));
CardFooter.displayName = "CardFooter";

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent };
